import { Card } from '@atd/rui-base.mui.card'
import { CARD_SX } from '../ravenV5Theme'
import ContentLoader from 'react-content-loader'
import React from 'react'

const JobCardLoader = (props) => (
    <div className="jobCard">
        <Card sx={{...CARD_SX, '& .MuiCardContent-root:last-child': {paddingBottom: 0}}}>
            <ContentLoader
                speed={2}
                width={'100%'}
                height={112}
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                {...props}
            >
                <rect x="16" y="16" rx="3" ry="3" width="45%" height="15" />
                <rect x="16" y="42" rx="3" ry="3" width="35%" height="14" />
                <rect x="16" y="66" rx="3" ry="3" width="35%" height="14" />
                <rect x="16" y="90" rx="3" ry="3" width="60%" height="14" />
            </ContentLoader>
        </Card>
    </div>
)

export default JobCardLoader
